import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './PhoneForm.css';

export default function PhoneForm() {
  const [phone, setPhone] = useState('');
  const navigate = useNavigate();

  const handleSubmit = e => {
    e.preventDefault();
    if (phone.trim()) {
      navigate(`/chat/${encodeURIComponent(phone.trim())}`);
    }
  };

  return (
    <div className="phone-form-page">
      <div className="phone-form-container">
        <h2>Enter Your Phone Number</h2>
        <form onSubmit={handleSubmit} className="phone-form">
          <input
            type="tel"
            placeholder="+91‑XXXXXXXXXX"
            value={phone}
            onChange={e => setPhone(e.target.value)}
          />
          <button type="submit">Start Chat</button>
        </form>
      </div>
    </div>
  );
}
